import React from 'react'
import Underline from '../Shared/Underline'

const Blogs = () => {
  return (
    <section id='blogs' className='py-20 bg-gray-100'>
      <div>
        <h2 className='text-2xl font-bold tracking-widest capitalize text-center'>
          blogs
        </h2>
        <Underline margintop='mt-2' />
      </div>
      <h1 className='text-center text-xl'>Coming Soon...</h1>
    </section>
  )
}

export default Blogs
